import { useFormSubmit } from 'hooks';
import { ReactNode, useEffect, useId, useState } from 'react';
import { FieldValues, UseFormResetField } from 'react-hook-form';
import { useAppDispatch } from 'store/hooks';
import { setCurrentRadioState } from 'store/slices/radioCardSlice';
import styles from './StepComponent.module.scss';

export interface StepComponentProps {
	fields?: Fields;
	resetField?: UseFormResetField<FieldValues>;
	children?: ReactNode;
}

const compositeTypes = ['DatePickerFieldBlock', 'RadioCardFieldBlock', 'InputTextfieldBlock'];
export const StepComponent: React.FC<StepComponentProps> = ({ fields, resetField, children }) => {
	const [key, setKey] = useState<string>(useId());
	const [stepName, setStepName] = useState<string>(undefined);
	const [hasCompositeComponents, setHasCompositeComponents] = useState<boolean>(false);
	const [hasRadioField, setHasRadioField] = useState<boolean>(false);
	const { resetFormField } = useFormSubmit();
	const dispatch = useAppDispatch();

	useEffect(() => {
		initCompositeTypes();
	}, []);

	const handleCompositeTypes = (e) => {
		const el = e.target;
		if (el instanceof HTMLInputElement) {
			if (hasRadioField && el?.type === 'text') {
				// TODO clear other textField types except this
				dispatch(setCurrentRadioState({ index: -1, name: stepName }));
				resetFormField(stepName);
				resetField && resetField(stepName);
			} else if (el?.type === 'radio') {
				//reset all - including value in dateField
				setKey(key + '1');
			}
		}
	};

	const initCompositeTypes = () => {
		let lastContentType: string;
		fields?.items?.forEach((item) => {
			if (compositeTypes.includes(item.content.contentType)) {
				if (!lastContentType) {
					lastContentType = item.content.contentType;
				} else if (item.content.contentType !== lastContentType) {
					setHasCompositeComponents(true);
					setStepName(item.content.uniqueIdentifier?.uid);
				}
			}
			if (item.content.contentType === 'RadioCardFieldBlock') {
				setHasRadioField(true);
			}
		});
	};

	return (
		<div
			key={key}
			onClick={hasCompositeComponents ? handleCompositeTypes : undefined}
			className={styles.StepComponent}
		>
			{children}
		</div>
	);
};
